import { Component, Input } from '@angular/core';
import { UserAsset } from '@models/dashboard.model';
import { OrderTypeSettings } from '@models/shopping.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

import { AssetCardComponent } from '../asset/card/asset-card.component';

@Component({
  selector: 'ts-device-to-upgrade',
  templateUrl: './device-to-upgrade.component.html',
  imports: [TranslationPipe, AssetCardComponent]
})
export class DeviceToUpgradeComponent {
  @Input() order_type_settings: OrderTypeSettings;
  @Input() asset: UserAsset;
  @Input() keep_plan: boolean | undefined;
  @Input() card_wrap: boolean = true;
  @Input() class: string = '';
}
